module.exports = __webpack_public_path__ + "img/business.029f7966.png";